import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "../modal";
import { RillContext } from "../../rill/RillReact/share/base";

class SuggestUpgrade extends React.Component {
  async componentDidMount() {
    const { api } = this.props;
    const { locals } = this.context;
    const hideHeader = locals.query.hideHeader;
    if (hideHeader && api) {
      await api(`upgrade-from-ios`, {
        method: "PUT",
        body: { action: "add" },
      });
    }
  }
  render() {
    const { t } = this.props;
    const hideHeader = this.context.locals.query.hideHeader;
    return (
      <Modal width="600px">
        <div className="head">
          <h2 className="alt">{t("suggestUpgrade.title")}</h2>
        </div>

        <div className="body">
          <p>{t("suggestUpgrade.accessDescription")}</p>
        </div>

        {!hideHeader && (
          <div className="foot">
            <a href="/dashboard/settings/subscription">
              {" "}
              <button className="button-input full">
                {t("suggestUpgrade.manageSubscription")}
              </button>{" "}
            </a>
          </div>
        )}
      </Modal>
    );
  }
}

SuggestUpgrade.contextType = RillContext;

export default withTranslation("coaching-portal")(SuggestUpgrade);
